import { Component, Input, Output, EventEmitter, output, SimpleChanges } from '@angular/core';
import { PatientsData } from '../../models/commonmodel';
import { CommonModule } from '@angular/common';
import { AgePipe } from '../shared/pipes/age.pipe';
import { StatusLablesComponent } from '../shared/components/status-lables/status-lables.component';
import { NoDataFoundComponent } from '../shared/no-data-found/no-data-found.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InitialsPipe } from '../shared/pipes/intials.pipe';

@Component({
  selector: 'app-table-card-view',
  standalone: true,
  imports: [
    CommonModule,
    AgePipe,
    StatusLablesComponent,
    NoDataFoundComponent,
    MatTooltipModule,
    InitialsPipe
  ],
  templateUrl: './table-card-view.component.html',
  styleUrl: './table-card-view.component.scss'
})
export class TableCardViewComponent {
goToPage(pageNumber: number) {
  if(pageNumber>0){
    this.currentPage=pageNumber;
    this.updateVisibleData();
  }

}
currentPage: number=1;
nextPage() {
if(this.currentPage>0){
  this.currentPage++;
  this.updateVisibleData()
}
}
prevPage() {
if(this.currentPage>1 && this.currentPage!=0 ){
  this.currentPage--;
  this.updateVisibleData()
}
}

  
  openPatientForm(arg0: any) {
    throw new Error('Method not implemented.');
  }
  defaultdate: string = '01/01/2000'
  @Input() data: PatientsData[] = [];
  @Input() enumRole: any;
  @Input() enumEntityType: any;
  @Input() getTurnAroundTime: (row: any) => string = () => '';
  @Output() openPatientProfile = new EventEmitter<any>();
  @Output() openMedicalEvidence = new EventEmitter<any>();
  @Output() openRequestMoreDetails = new EventEmitter<any>();
  @Output() openAddPatientModal = new EventEmitter<any>();
  @Output() openRequestME = new EventEmitter<any>();
  @Output() onFillMoreInfo = new EventEmitter<any>();
  @Output() onViewDocuments = new EventEmitter<any>();
  @Output() openEditForm =new EventEmitter<any>(); 

  pageSize:number=6;
  items :PatientsData[]=[];
  paginatedData:PatientsData[]=[];
 totalPages:number=0;
  ngOnInit(){
    
    console.log(this.enumRole);
    console.log( "the data is " +this.data)
    this.items=this.data;
    this.intialPagination();
     this.calculatePages();
     this.updateVisibleData();}
  ngOnChanges(changes:SimpleChanges){
    if(changes['data']){
       console.log(this.enumRole);
    console.log( "the data is " +this.data)
    this.items=this.data;
    this.intialPagination();
     this.calculatePages();
     this.updateVisibleData()


    }

    
      
    }
  

  getTurnAroundTimes = (row: any): string => {
    if (!row) {
      return '';
    }
    const createdOn = new Date(row.createdon);
    const now = new Date();
    if (row.status?.toLowerCase() !== 'received') {
      return this.formatDuration(createdOn, now);
    } else {
      const lastUpdatedOn = new Date(row.lastupdatedon);
      return this.formatDuration(createdOn, lastUpdatedOn);
    }
  }

  private formatDuration(start: Date, end: Date): string {
    let msDiff = end.getTime() - start.getTime();

    if (msDiff < 0) {
      msDiff = 0;
    }

    let totalMinutes = Math.floor(msDiff / (1000 * 60));

    const years = Math.floor(totalMinutes / (60 * 24 * 365));
    totalMinutes -= years * 60 * 24 * 365;

    const months = Math.floor(totalMinutes / (60 * 24 * 30));
    totalMinutes -= months * 60 * 24 * 30;

    const weeks = Math.floor(totalMinutes / (60 * 24 * 7));
    totalMinutes -= weeks * 60 * 24 * 7;

    const days = Math.floor(totalMinutes / (60 * 24));
    totalMinutes -= days * 60 * 24;

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const parts = [];

    if (years) parts.push(`${years}y`);
    if (months) parts.push(`${months}m`);
    if (weeks) parts.push(`${weeks}w`);
    if (days) parts.push(`${days}d`);
    if (hours) parts.push(`${hours}hrs`);
    if (minutes || parts.length === 0) parts.push(`${minutes}m`);

    return parts.join(' ');
  }
  intialPagination() :void{
    
    this.paginatedData=this.items.slice(0,this.pageSize)
    console.log(this.paginatedData.length)
  }
  calculatePages() :void{

    this.totalPages=Math.ceil(this.items.length/this.pageSize);
    console.log(this.totalPages)
  }
  updateVisibleData() :void{
    const start =(this.currentPage-1)*this.pageSize;
    const end=start+this.pageSize;
    this.paginatedData=this.items.slice(start,end);
    console.log("the paginated data is"+ this.paginatedData)
  }
  
}
